import { render, staticRenderFns } from "./ModalContact.vue?vue&type=template&id=acc79a5a&scoped=true"
import script from "./ModalContact.vue?vue&type=script&lang=js"
export * from "./ModalContact.vue?vue&type=script&lang=js"
import style0 from "./ModalContact.vue?vue&type=style&index=0&id=acc79a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc79a5a",
  null
  
)

export default component.exports